import type { i18n } from 'i18next';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

export function LocaleProvider({ i18nInstance, children }: { i18nInstance: i18n; children: ReactNode }) {
	return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
